import $ from 'jquery';
import EFOcats_logic from '../efocats_logic.js';
import EFOcats_import_html from '../import/efocats_import_html.js';
import EFOcats_import_style from '../import/efocats_import_style.js';

import EFOcats_answer_calendar from '../answer/efocats_answer_calendar.js';
import EFOcats_answer_checkbox from '../answer/efocats_answer_checkbox.js';
import EFOcats_answer_radio from '../answer/efocats_answer_radio.js';
import EFOcats_answer_select from '../answer/efocats_answer_select.js';
import EFOcats_answer_textarea from '../answer/efocats_answer_textarea.js';
import EFOcats_answer_required from '../answer/efocats_answer_required.js';
import EFOcats_answer_set_adress from '../answer/efocats_answer_set-adress.js';
import EFOcats_answer_common from '../answer/efocats_answer_common.js';
import EFOcats_answer_nini from '../answer/efocats_answer_nini.js';

export default class EFOcats_making extends EFOcats_logic {
  /**
   * コンストラクタ
   */
  constructor() {
    super();
    // 回答欄
    this.answersettings = {
      calendar: new EFOcats_answer_calendar(),
      checkbox: new EFOcats_answer_checkbox(),
      radio: new EFOcats_answer_radio(),
      select: new EFOcats_answer_select(),
      textarea: new EFOcats_answer_textarea(),
      required: new EFOcats_answer_required(),
      set_adress: new EFOcats_answer_set_adress(),
      common: new EFOcats_answer_common(),
      nini: new EFOcats_answer_nini(),
    };

    this.answers = [];

    this.efocats_style = document.createElement('style');

    this.frameElem = document.createElement('main');
    this.frameElem.id = 'efocats';
    this.frameElem.className = 'efo-cat-main';

    this.iframe = document.createElement('iframe');
    this.iframe.width = '100%';
    this.iframe.style.border = 'none';
    this.iframe.className = 'efocats_frame';

    this.loadingdivElem = document.createElement('div');
    this.loadingdivElem.id = 'loaderWrap';
    this.loadingdivElem.innerHTML = EFOcats_import_html.getValue('loading');
  }

  /**
   * 初期化
   */
  initialize(targetQurey) {
    this.style();
    this.area(targetQurey);
  }

  focus() {
    // フォーカスしない
  }

  /**
   * ラベルに対応したテンプレートを読み込み、ボタン等の共通パーツを設置する
   * @param tmp テンプレート名
   * @param number ラベルの番号
   * @returns テンプレート
   */
  template(tmp, number) {
    const tmphtml = require(`../../../html/v2/${tmp}.html`);
    const elem = $(tmphtml);
    return elem;
  }

  /**
   * フレームに対するスタイルを設定、設置する
   */
  style() {
    this.efocats_style.textContent = EFOcats_import_style.getValue('frame-style');

    // formを削除するためのCSSを設置
    document.head.appendChild(this.efocats_style);
  }

  /**
   * フレームの設置先となるエリアを設置する
   */
  area(targetQurey) {
    // mainタグを作成し、classを付加
    this.loading(true);

    // ロード後、読み込み・組み立て
    const initInsertTimer = efocats.setInterval(() => {
      const target = document.querySelector(targetQurey);
      if (target) {
        efocats.clearInterval(initInsertTimer);
        target.appendChild(this.frameElem);
      }
    }, 100);
  }

  /**
   * 画面作成コントローラー
   * @param {*} id
   * @param {*} form_id
   * @param {*} editdata
   */
  build(id, form_id, editdata) {
    this.frame();
    this.base();

    const dataLabel = editdata.form.label;
    const html = {};

    for (let number = 0; number < dataLabel.length; number++) {
      this.build_page(dataLabel, number, html);
    }

    this.write(html);
    this.form_extend();
    this.translation();
    this.focus();
  }

  /**
   * ページ作成
   * @param {*} dataLabel
   * @param {*} number
   * @param {*} html
   */
  build_page(dataLabel, number, html) {
    const tmp = Object.keys(dataLabel[number]);

    const elem = this.template(tmp[0], number);
    const label_tmp = dataLabel[number][tmp];

    this.add(label_tmp, elem);
    this.question(label_tmp, elem);

    const answers = dataLabel[number][tmp].answer;

    if (answers) {
      answers.forEach(answer => {
        this.answer(tmp, answer, elem);
      });
    }

    this.page_extend(label_tmp, elem, number);

    html[number] = elem[0].outerHTML;
  }

  /**
   * フレームの設置、調整
   * @returns 設定したフレーム
   */
  frame() {
    this.frameElem.innerHTML = '';
    this.frameElem.appendChild(this.iframe);

    if (this.iframe.offsetWidth < 600) {
      this.iframe.height = '500';
    } else {
      this.iframe.height = '700';
    }
  }

  /**
   * フレーム内のベースとなるHTMLを設置
   */
  base() {
    const baseHtml = EFOcats_import_html.getValue('base-html');

    const iframe_document = this.iframe.contentDocument || this.iframe.contentWindow.document;

    iframe_document.open();
    iframe_document.write(baseHtml);
    iframe_document.close();

    iframe_document.querySelector('html').classList.add('formcatShow');

    // スタイルを読み込む
    require('../../../scss/v2/reset.scss');
    $(this.iframe).contents().find('head').append($('head').find('style').last());
    require('../../../scss/v2/index.scss');
    $(this.iframe).contents().find('head').append($('head').find('style').last());
  }

  /**
   * loading画像表示/非表示
   * @param flg true=表示 false=非表示
   */
  loading(flg) {
    if (flg) {
      this.frameElem.appendChild(this.loadingdivElem);
    } else if (this.loadingdivElem.parentElement) {
      this.frameElem.removeChild(this.loadingdivElem);
    }
  }

  /**
   * エラー時の処理
   */
  error() {
    if (this.efocats_style.parentElement) {
      this.efocats_style.remove();
    }

    this.loading(false);

    if (this.frameElem.parentElement) {
      this.frameElem.remove();
    }

    $('.efocats_style').remove();
  }

  /**
   * スタイル設置済か確認
   */
  isLoaded() {
    const deferr = new $.Deferred();

    $(() => {
      deferr.resolve();
    });

    return deferr.promise(this);
  }

  /**
   * ラベルの追加テキストを設置する
   * @param label_tmp
   * @param elem
   */
  add(label_tmp, elem) {
    Object.keys(label_tmp).forEach(key => {
      if (key === 'add') {
        Object.keys(label_tmp[key]).forEach(key2 => {
          elem.find(`.${key2}`).html(this.htmlunescape(label_tmp[key][key2]).replace(/\r?\n/g, '<br>'));
        });
      }
    });
  }

  /**
   * エスケープ文字を変換する
   * @param 変換前の文字列
   * @return 変換後の文字列
   */
  htmlunescape(text) {
    return text
      .replace(/&gt;/g, '>')
      .replace(/&lt;/g, '<')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&');
  }

  /**
   * 質問文を設置する
   * @param label_tmp
   * @param elem
   */
  question(label_tmp, elem) {
    const textLabel = label_tmp.question;
    elem.find('.cat-txt').html(textLabel);
  }

  /**
   * ページの拡張
   * @param label_tmp
   * @param elem
   * @param number
   */
  page_extend(label_tmp, elem, number) {
    // 複数のテキストボックスが１ページにある場合のクラス付与
    if (!elem.hasClass('address-section') && !elem.hasClass('no-flex-section')) {
      elem.find('.inner').each((index, element) => {
        if ($(element).find('input[type="text"]').length > 1) {
          $(element).addClass('efocatsFlex');
        }
      });
    }
  }

  /**
   * 回答欄設置クラスの使用条件設定
   */
  set_answers(tmp, answer, elem) {
    this.answers = [];

    // 入力欄のタイプ
    if (this.answersettings[answer.type]) {
      this.answers.push(answer.type);
    } else {
      this.answers.push('common');
    }

    // 必須
    if (answer['data-required'] && answer['data-required'] === '1') {
      this.answers.push('required');
    }

    // カスタマイズ
    if (answer['answer-type']) {
      const types = answer['answer-type'].split(',');

      types.forEach(type => {
        this.answers.push(type.trim());
      });
    }
  }

  /**
   * 回答欄を設置する
   */
  answer(tmp, answer, elem) {
    this.set_answers(tmp, answer, elem);

    Object.keys(this.answers).forEach(key => {
      if (this.answersettings[this.answers[key]]) {
        const answersetting = this.answersettings[this.answers[key]];
        // 設置を実行する
        answersetting.set(tmp, answer, elem);
      }
    });
  }

  /**
   * フレーム内に作成した回答欄などを書き込む
   * @param html
   */
  write(html) {
    let htmlTxt = '';

    Object.keys(html).forEach(key => {
      htmlTxt += html[key];
    });

    this.$('.cat-container').prepend(htmlTxt);
  }

  /**
   * go-flg付与、送信ボタン設置などの仕上げ処理
   */
  form_extend() {
    // go-flagのクラスを付加
    this.$('.qa').addClass('go-flag');

    // 必須項目がある場合はgo-flagを除去
    this.$('.required').parents('.qa').removeClass('go-flag');

    // 必須項目が全て入力済みならgo-flagを再付加
    this.$('.qa').each((index, qa) => {
      let noinput = false;
      const inputs = $(qa).find('.required').find('input,select,textarea');

      for (let inputsIndex = 0; inputsIndex < inputs.length; inputsIndex++) {
        const input = inputs.eq(inputsIndex);

        if (input.attr('type') !== undefined && ['radio', 'checkbox'].includes(input.attr('type'))) {
          const name = input.attr('name');
          if ($(qa).find(`input[name="${name}"]:checked`).length === 0) {
            noinput = true;
            break;
          }
        } else if (input.val() === '') {
          noinput = true;
          break;
        }
      }

      if (!noinput) {
        $(qa).addClass('go-flag');
      }
    });

    // 送信ボタン生成
    if (this.$('.checkPage').length === 0) {
      this.$('body').find('.cat-section:last-child').find('.pager').html(EFOcats_import_html.getValue('btn_submit'));
    }

    // スクロール対策用に白紙のレイヤーを噛ませる
    $('body').append(EFOcats_import_html.getValue('dummy-layer'));
    $('#cat-dummy-layer').height($('body').height());

    // iOSのChrome対応
    this.$('select').append('<optgroup></optgroup>');

    // 選択肢に変更があった時にもoptgroupが追加されるようにする
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if ($(mutation.target).children('optgroup').length === 0) {
          $(mutation.target).append('<optgroup></optgroup>');
        }
      });
    });

    this.$('select').each((index, element) => {
      // 監視の開始
      observer.observe(element, {
        childList: true,
      });
    });
  }

  /**
   * 言語置換
   */
  translation() {
    if (this.$('.checkPage').length > 0) {
      const target = this.$('.qa:visible');
      const target_btn = target[target.length - 1];
      this.$('.qa').find('.next-btn').html(this.langagerList('次へ'));
      this.$(target_btn).find('.next-btn').html(this.langagerList('内容確認'));
    }

    this.$('.required .cat-txt-design').attr('data-text', this.langagerList('必須'));
    this.$('.qa .next-btn-design').text(this.langagerList('次へ'));
    this.$('.prev-btn-design').text(this.langagerList('戻る'));
    this.$('.submit-btn').text(this.langagerList('送信'));
  }
}
